import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

const STATS = [
  { value: 1998, label: "óta a szakmában", animate: false },
  { value: 20, suffix: "+", label: "év tapasztalat", animate: true },
  { value: 7, label: "fő szolgáltatás", animate: true },
  { value: 2, label: "ország lefedettség", animate: true },
];

function CountUp({ target, animate, active }) {
  const [n, setN] = useState(animate ? 0 : target);

  useEffect(() => {
    if (!active || !animate) return;
    let raf;
    const duration = 1400;
    const start = performance.now();
    const tick = (now) => {
      const p = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(Math.round(target * eased));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [active, animate, target]);

  return <>{n}</>;
}

export default function Stats() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section ref={ref} data-testid="stats-section" className="relative overflow-hidden bg-[#0E5A75] py-16 md:py-20">
      <div className="absolute inset-0 noise-overlay opacity-[0.12]" />
      <div className="pointer-events-none absolute -top-20 left-1/3 h-64 w-64 rounded-full bg-emerald-400/20 blur-3xl" />

      <div className="relative mx-auto grid max-w-7xl grid-cols-2 lg:grid-cols-4 gap-y-10 gap-x-6 px-5 md:px-10">
        {STATS.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 24 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
            data-testid={`stat-${i}`}
            className="relative text-center sm:text-left"
          >
            <div className="hidden sm:block absolute right-0 top-1 h-16 w-px bg-white/10 last:hidden" />
            <div className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white tabular-nums">
              <CountUp target={s.value} animate={s.animate} active={inView} />
              {s.suffix && <span className="text-emerald-400">{s.suffix}</span>}
            </div>
            <div className="mt-2 text-sm font-medium uppercase tracking-wider text-slate-300">{s.label}</div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
